import { Component, OnInit ,Inject } from '@angular/core';
import { PlaylistService } from '../../services/playlist.service';
import { MessageService } from '../../services/message.service';
import { UtilService } from '../../services/util.service';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { throwError ,pipe} from 'rxjs';
import { catchError } from 'rxjs/operators';
// import { DOCUMENT } from '@angular/common';
import { Constant } from '../../services/data';

import { Platform } from '@angular/cdk/platform';
import { AuthentictionService } from '../../services/authentiction.service';



@Component({
  selector: 'app-xstream-login',
  templateUrl: './xstream-login.component.html',
  styleUrls: ['./xstream-login.component.css']
})
export class XstreamLoginComponent implements OnInit {

  playListModal: any = {
    type: 'fromUrl',
    name: '',
    username: '',
    password: '',
    url: '',
    code:'',
    epg:'',
    pin:'',
    confirm_pin:'',
  };
  xcode:boolean=false;
  playList: any = [];
  xstreamList: any;
  isLoading: boolean = false;
  // url_pattern = "([a-z0-9-]+\:\/+)([^\/\s]+)([a-z0-9\-@\^=%&;\/~\+]*)[\?]?([^ \#\r\n]*)#?([^ \#\r\n]*)";
  url_pattern = "([a-z0-9-]+\:\/+)([a-z0-9\-@\^=%&;\/~\+]*)[\?]?([^ \#\r\n]*)#?([^ \#\r\n]*)";
  codeData:any =[];
  code:any;
  urlValue = '';
  platformInfo: string;
  browserInfo:any
  type='password';
  userid: any
  filterPlayList:any =[];
  validXstream:boolean = false;
  isPlaylist:boolean = false;

  constructor(private platform:Platform,private http:HttpClient ,private utilService: UtilService, private playlistService: PlaylistService,private authService:AuthentictionService, private messageService: MessageService, private router: Router)
   {
   
    }

  ngOnInit(): void {
    const UserData = JSON.parse(this.utilService.getFullUserId()) || '' ;
    console.log(UserData,'local storage');
    
    this.userid = UserData.user_id
    // this.playListModal.type = "onestreamUrl"
    if (this.userid) {
      console.log(this.userid,'onin');
      this.getPlayList();
    }else{

    }
    
  }
  

  getPlayList() {
    this.playList = [];
    let passModel: any = {
      userid: ''
    };
    
    passModel.userid = this.utilService.getFullUserId();

    this.utilService.showSpinner()
    this.isLoading = true;
    this.playlistService.getNewPlaylist().subscribe((res:any) =>{
      if(res.status === 'success'){
        console.log(res);
        this.playList = res.data
        this.filterPlayList = res.data
        this.isLoading = false;
        const localPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
        this.filterPlayList = [...this.filterPlayList, ...localPlaylists];
        console.log(this.filterPlayList,'asdf');
        this.utilService.hideSpinner();
      }
    },err =>{
      this.isLoading = false;
      this.utilService.hideSpinner();
    })
  }

  checkDuplicateName(name) {
    let found = false;
    const inputName = name.toLowerCase();
    for (let index = 0; index < this.filterPlayList.length; index++) {
      const existingName = this.filterPlayList[index].playlist_name.toLowerCase();
      if (existingName === inputName) {
        found = true;
        this.utilService.showErrorToast('', 'Playlist name must be unique');
        break;
      }
    }
    return !found;
  }

  
  addPlaylistXstream(form: NgForm) {
    console.log(this.playListModal);
    
    if (form.valid && this.checkDuplicateName(this.playListModal.name)) {
      let passModel: any = {
        type: 1,
        url: this.playListModal.url,
        pwd: this.playListModal.password,
        name: this.playListModal.name,
        username: this.playListModal.username
      };
  
      this.isLoading = true;
      this.utilService.showSpinner();
      console.log(passModel);
  
      this.authService.validateXstreamGET(passModel.url, passModel.username, passModel.pwd).subscribe((res: any) => {
        if (res?.user_info) {
          this.handleValidXstream(passModel);
        } else {
          this.authService.validateXstreamPOST(passModel.url, passModel.username, passModel.pwd).subscribe((postRes: any) => {
            if (postRes?.user_info) {
              this.handleValidXstream(passModel);
            } else {
              this.isLoading = false;
              this.utilService.hideSpinner();
              this.utilService.showErrorCall('Invalid credentials from both GET and POST');
            }
          }, err => {
            this.isLoading = false;
            this.utilService.hideSpinner();
            this.utilService.showErrorCall(err);
          });
        }
      }, err => {
        this.authService.validateXstreamPOST(passModel.url, passModel.username, passModel.pwd).subscribe((postRes: any) => {
          if (postRes?.user_info) {
            this.utilService.saveAPImethod(Constant.APIMETHOD,'post'); // Optional utility method
            this.handleValidXstream(passModel);
          } else {
            this.isLoading = false;
            this.utilService.hideSpinner();
            this.utilService.showErrorCall('Invalid credentials from both GET and POST');
          }
        }, err => {
          this.isLoading = false;
          this.utilService.hideSpinner();
          this.utilService.showErrorCall(err);
        });
      
        this.isLoading = false;
        this.utilService.hideSpinner();
        this.utilService.showErrorCall(err);
      });
    }
  }
  handleValidXstream(passModel: any) {
    if (this.playList.length < 5 && this.userid) {
      this.playlistService.addNewXstreamPlaylist(passModel).subscribe((res: any) => {
        this.isLoading = false;
        this.utilService.hideSpinner();
        if (res.status === 'success') {
          this.utilService.showErrorSuccess('Xstream playlist is added successfully');
          this.getPlayList();
          this.router.navigate(['/playlist']);
          this.resetPlaylistModal();
        }
      }, err => {
        this.isLoading = false;
        this.utilService.hideSpinner();
        this.utilService.showErrorCall(err);
      });
    } else {
      const fakeResponse = {
        status: 'success',
        message: 'Playlist added successfully',
        data: {
          user_id: this.userid,
          playlist_name: passModel.name,
          type: passModel.type,
          reseller_code: null,
          dns: passModel.url,
          username: passModel.username,
          password: passModel.pwd,
          epg: null,
          user_agent: null,
          updated_at: new Date().toISOString(),
          created_at: new Date().toISOString(),
          id: Date.now(),
          local: true
        }
      };
  
      let localPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
      localPlaylists.push(fakeResponse.data);
      localStorage.setItem('xstream_playlists', JSON.stringify(localPlaylists));
      this.filterPlayList.push(fakeResponse.data);
      this.isLoading = false;
      this.utilService.hideSpinner();
      this.utilService.showErrorSuccess(fakeResponse.message);
      this.router.navigate(['/playlist']);
      this.resetPlaylistModal();
    }
  }
  
  resetPlaylistModal() {
    this.playListModal = {
      type: 'fromUrl',
      name: '',
      userName: '',
      password: '',
      url: ''
    };
  }
  
  
  
  addPlaylistXstreams(form: NgForm) {
    if (form.valid && this.checkDuplicateName(this.playListModal.name)) {
      let passModel: any = {
        type:1,
        url: this.playListModal.url,
        pwd: this.playListModal.password,
        name: this.playListModal.name,
        username: this.playListModal.userName
      };
      this.isLoading = true;
      this.utilService.showSpinner();
      
      if(this.playList.length < 5  && this.userid){
        this.playlistService.addNewXstreamPlaylist(passModel).subscribe((res: any) => {
          this.isLoading = false;
          this.utilService.hideSpinner()
  
          if (res.status == 'success') {
            this.utilService.showErrorSuccess('xstream playlist is added successfully');
            this.getPlayList();
            this.router.navigate(['/playlist'])
            this.playListModal = {
              type: 'fromUrl',
              name: '',
              userName: '',
              password: '',
              url: ''
            };
          }
        }, err => {
          this.isLoading = false;
          this.utilService.hideSpinner()
  
          this.utilService.showErrorCall(err);
        });
      }else{
        const fakeResponse = {
          status: 'success',
          message: 'Playlist added successfully',
          data: {
            user_id: this.userid, 
            playlist_name: passModel.name,
            type: passModel.type,
            reseller_code: null,
            dns: passModel.url,
            username: passModel.username,
            password: passModel.pwd,
            epg: null,
            user_agent: null,
            updated_at: new Date().toISOString(),
            created_at: new Date().toISOString(),
            id: Date.now(),
            local:true
          }
        };
  
        let localPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
        localPlaylists.push(fakeResponse.data);
        localStorage.setItem('xstream_playlists', JSON.stringify(localPlaylists));
        this.filterPlayList.push(fakeResponse.data);
        this.isLoading = false;
        this.utilService.hideSpinner();
        this.utilService.showErrorSuccess(fakeResponse.message);
        this.router.navigate(['/playlist'])
        this.playListModal = {
          type: 'fromUrl',
          name: '',
          userName: '',
          password: '',
          url: ''
        };
      }
    }
  }

skip(){
 this.isPlaylist = this.authService.isPlayList();
 if(this.isPlaylist == true){
  this.router.navigate(['/playlist'])
 }else{
  this.router.navigate(['/add-playlist'])
 }
}
  
hideShowPassword(){
  if(this.type === 'password'){
    this.type = 'text';
  }
  else{
    this.type='password';
  }
}
  

}
